// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2wsHQ","label":"Section_label__2JamC","contentWrap":"Section_contentWrap__3fY7E","footer":"Section_footer__45cwF","footerInner":"Section_footerInner__2no3u"};